import React, { useMemo } from "react";

import { PlatformUsage } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { CHARACTER_LIMITS } from "constants/CharacterLimits";
import CaptionField from "./CaptionField";
import { PlatformSpec } from "../../../../constants/Platforms";
import {
  AccountPlatformType,
  PostLinkedInAccountType,
} from "../../../../shared/types/accounts";
import {
  FormValidationErrors,
  FormValidationWarnings,
} from "../../../../shared/types/post";
import { SkedEditorHistory } from "../../../../ui/SkedCaption/v2/sked-caption-v2";

const PostCaption = ({
  platforms,
  selectedPlatform,
  post,
  onChange,
  errors = {},
  warnings = {},
  className = "",
  disabled = false,
  hashtagCount,
  hasMoreThanOnelinkedInAccount,
  selectedLinkedInAccountType,
  selectedLinkedUrn,
  formId,
  captionEditHistory,
}: {
  platforms: PlatformSpec[];
  selectedPlatform: AccountPlatformType | "LINKED";
  post: { caption?: string };
  onChange: (value: string) => void;
  errors?: FormValidationErrors;
  warnings?: FormValidationWarnings;
  className?: string;
  disabled?: boolean;
  hashtagCount: number;
  hasMoreThanOnelinkedInAccount?: boolean;
  selectedLinkedInAccountType?: PostLinkedInAccountType;
  selectedLinkedUrn?: string;
  formId?: string;
  captionEditHistory?: SkedEditorHistory;
}) => {
  const caption = useMemo(() => post.caption || "", [post]);
  const hasYT = platforms.some((platform) => platform.TYPE === "YT");
  const hasPI = platforms.some((platform) => platform.TYPE === "PI");
  // Get the lowest character limit from postPlatformConfig
  const limits = platforms.map(
    (p) => CHARACTER_LIMITS[p.TYPE] || CHARACTER_LIMITS.FB
  );
  const length = Math.min(...limits);

  return (
    <CaptionField
      label={
        <>
          <div className="mr-2">Caption</div>
          {hasYT &&
            ["LINKED", "YT"].includes(selectedPlatform) &&
            " (YouTube video description)"}
          {hasPI &&
            ["LINKED", "PI"].includes(selectedPlatform) &&
            " (Pin description)"}
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.CAPTION}
            selectedPlatform={selectedPlatform}
          />
        </>
      }
      hashtagCount={hashtagCount}
      className={className}
      value={caption}
      disabled={disabled}
      onChange={onChange}
      maxLength={length}
      errors={errors}
      warnings={warnings}
      selectedPlatform={selectedPlatform}
      platforms={platforms}
      hasMoreThanOnelinkedInAccount={hasMoreThanOnelinkedInAccount}
      selectedLinkedInAccountType={selectedLinkedInAccountType}
      selectedLinkedUrn={selectedLinkedUrn}
      formId={formId}
      captionEditHistory={captionEditHistory}
    />
  );
};

export default PostCaption;
